export default __webpack_public_path__ + "static/app-1-ec64a650f62a84e7aac3f4b806af3046.webp";